<article class="card-wrapper client-card">
    <div
        [ngClass]="{
            'client-card-section': !shouldRedirectToClientDetails,
            'client-card-section-clickable': shouldRedirectToClientDetails
        }"
        (click)="redirectToClientDetails()"
    >
        <div class="client-card-header">
            <span class="client-card-title">
                {{ clientTitle }}
                @if (clientExternalSystemId) {
                    ({{ clientExternalSystemId }})
                }
            </span>
            @if (showEditActions()) {
                <div class="buttons">
                    <app-svg-icon icon="edit-action" />
                    <span class="text" [routerLink]="'/app/clients/edit/' + clientId">
                        {{ 'Edit' | localize }}
                    </span>
                </div>
            }
        </div>
        @if (client?.personalData?.isDeceased) {
            <app-svg-icon class="deceased-icon" icon="deceased" />
        }
        <span class="client-card-name">{{ clientName }}</span>
    </div>
    <div class="client-card-section">
        @if (isLegalEntity(clientTypeName)) {
            <div class="client-card-c-letter">
                <app-svg-icon icon="c-letter-black" />
                <span>{{ clientUnifiedIdentificationCode }}</span>
            </div>
        }
        @if (canViewData) {
            <div class="client-card-phone">
                <app-svg-icon icon="phone-ringing" />
                @for (phone of clientPhones; track $index) {
                    @if ($index < clientPhones.length - 1) {
                        <a [href]="phone | phoneNumber" class="text">{{ phone }},</a>
                    } @else {
                        <a [href]="phone | phoneNumber" class="text">{{ phone }}</a>
                    }
                }
            </div>
        }
        <div class="client-card-email">
            <app-svg-icon icon="envelope" />
            @for (email of clientEmails; track $index) {
                @if ($index < clientEmails.length - 1) {
                    <a [href]="email | email" class="text">{{ email }},</a>
                } @else {
                    <a [href]="email | email" class="text">{{ email }}</a>
                }
            }
        </div>
    </div>

    @if (isExpanded) {
        <div class="client-card-extended">
            @if (showActions()) {
                <app-actions-cta [menuItems]="menuItems"></app-actions-cta>
            }

            <hr class="separator" />

            @if (canViewData) {
                <div class="client-card-extended-details">
                    <div class="client-card-extended-details-info">
                        @if (clientWorkplace) {
                            <span class="client-card-extended-details-info-text">
                                <span class="bold">{{ 'Workplace' | localize }}:</span>
                                {{ clientWorkplace }}
                            </span>
                        }
                        @if (clientPosition) {
                            <span class="client-card-extended-details-info-text">
                                <span class="bold">{{ 'Position' | localize }}:</span>
                                {{ clientPosition }}
                            </span>
                        }
                        @if (clientBirthDate) {
                            <span class="client-card-extended-details-info-text">
                                <span class="bold">{{ 'BirthDate' | localize }}:</span>
                                {{ clientBirthDate | formatDate }}
                            </span>
                        }
                        @if (clientSectors) {
                            <span class="client-card-extended-details-info-text">
                                <span class="bold">{{ 'Sector' | localize }}:</span>
                                {{ clientSectors }}
                            </span>
                        }
                        <span class="client-card-extended-details-info-text">
                            <span class="bold">{{ 'Source' | localize }}:</span>
                            {{ clientSource }}
                        </span>
                        @for (item of clientTagsByCategory; track item.category) {
                            <span class="client-card-extended-details-info-text">
                                <span class="bold">{{ item.category }}:</span>
                                {{ item.tags.join(', ') }}
                                </span>
                        }
                        @if (clientBusinessOrganizations) {
                            <span class="client-card-extended-details-info-text">
                                <span class="bold">{{ 'BusinessOrganization' | localize }}:</span>
                                {{ clientBusinessOrganizations }}
                            </span>
                        }
                        @if (clientSegments) {
                            <span class="client-card-extended-details-info-text">
                                <span class="bold">{{ 'Segment' | localize }}:</span>
                                {{ clientSegments }}
                            </span>
                        }
                        @if (clientEmbassy) {
                            <span class="client-card-extended-details-info-text">
                                <span class="bold">{{ 'Embassy' | localize }}:</span>
                                {{ clientEmbassy }}
                            </span>
                        }
                        @if(hasCertificate) {
                            <span class="client-card-extended-details-info-text">
                                <span class="bold">{{ 'ExternalBroker' | localize }}:</span>
                                {{ certificate }}
                            </span>
                        }
                        @if (clientPreferences) {
                            <span class="client-card-extended-details-info-text">
                                <span class="bold">{{ 'ClientPreferences' | localize }}:</span>
                                {{ clientPreferences }}
                            </span>
                        }
                    </div>
                </div>
            }
        </div>
    }

    @if (isExpandable) {
        <a href="#" class="client-card-read-more" (click)="toggleExpand($event)">
            {{ isExpanded ? ('Hide' | localize) : ('SeeMore' | localize) }}
        </a>
    }
</article>
